var map = {
	"./Default": 23064,
	"./Default.tsx": 23064,
	"./headers/Default": 29087,
	"./headers/Default.tsx": 29087,
	"./headers/FeedMenu": 4275,
	"./headers/FeedMenu.tsx": 4275,
	"./override.css": 73547
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 47033;